const CATEGORY_LABELS = {
  openai_call: "OpenAI",
  internal_rule: "Regra interna",
};

function parseJsonMaybe(raw) {
  if (raw == null) return null;
  if (typeof raw === "object") return raw;
  if (typeof raw !== "string") return null;
  try {
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function extractFromObject(obj) {
  if (!obj || typeof obj !== "object") return null;
  if (obj.kind === "ai_agent_audit") return obj;
  if (obj.xpro_ai_audit && typeof obj.xpro_ai_audit === "object") return obj.xpro_ai_audit;
  return null;
}

export function resolveMessageAiAudit(message) {
  if (!message) return null;
  if (message.aiAudit && typeof message.aiAudit === "object") return message.aiAudit;

  const fromWa = extractFromObject(parseJsonMaybe(message.json_whatsapp));
  if (fromWa) return fromWa;

  const ackRaw = message.json_status_message_ack;
  if (ackRaw) {
    return extractFromObject(parseJsonMaybe(ackRaw));
  }
  return null;
}

export function getAiAuditCategoryLabel(category) {
  return CATEGORY_LABELS[category] || String(category || "IA");
}

export function formatAiAuditJson(value) {
  if (value == null) return "";
  if (typeof value === "string") {
    try {
      return JSON.stringify(JSON.parse(value), null, 2);
    } catch {
      return value;
    }
  }
  try {
    return JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

export function buildAiAuditCopyBundle(audit) {
  if (!audit) return "";
  const lines = [
    `Categoria: ${getAiAuditCategoryLabel(audit.category)}`,
    `Operação: ${audit.operation || audit.featureKind || "—"}`,
    audit.model ? `Modelo: ${audit.model}` : null,
    audit.skillKey ? `Skill: ${audit.skillKey}` : null,
    audit.agentId != null ? `Agente: ${audit.agentId}` : null,
    audit.durationMs != null ? `Duração: ${audit.durationMs}ms` : null,
    audit.error ? `Erro: ${audit.error}` : null,
    "",
  ].filter((x) => x !== null);

  if (audit.category === "internal_rule") {
    lines.push("=== REGRAS ===", formatAiAuditJson(audit.rules), "");
    lines.push("=== CONTEXTO ===", formatAiAuditJson(audit.context));
  } else {
    lines.push("=== REQUEST ===", formatAiAuditJson(audit.request), "");
    lines.push("=== RESPONSE ===", formatAiAuditJson(audit.response));
    if (audit.usage) {
      lines.push("", "=== USAGE ===", formatAiAuditJson(audit.usage));
    }
  }
  return lines.join("\n");
}

export function looksLikeAiAgentLogText(text) {
  if (text == null) return false;
  const plain =
    typeof text === "string" && text.includes("<")
      ? text.replace(/<[^>]*>/g, "").trim()
      : String(text).trim();
  if (!plain) return false;
  return /^IA\s+(OpenAI|Regra)\b/i.test(plain) || /^IA\s+/i.test(plain);
}
